import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import exam from './modules/exam'
import paper from './modules/paper'
import permission from './modules/permission'
import user from './modules/user'
import { cacheSelectedItems } from './plugins/paper'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    exam,
    paper,
    permission,
    user
  },
  plugins: [cacheSelectedItems],
  getters: {
    addRouters: state => state.permission.addRouters
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js